import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import CurriculumVitate from 'views/curriciulum-vitae';

import './styles.css';

const mountNode = document.getElementById('root')!;

const applicationNode = (
	<StrictMode>
		<CurriculumVitate />
	</StrictMode>
);

if (import.meta.hot) {
	const root = (import.meta.hot.data.root ??= createRoot(mountNode));

	root.render(applicationNode);
} else {
	createRoot(mountNode).render(applicationNode);
}
